import axiosInstance from '../auth/axiosInstance';

function extractPagedItems(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const items = Array.isArray(payload.items)
    ? payload.items
    : Array.isArray(payload.Items)
      ? payload.Items
      : null;

  const totalCount =
    typeof payload.totalCount === 'number'
      ? payload.totalCount
      : typeof payload.TotalCount === 'number'
        ? payload.TotalCount
        : null;

  if (!items || totalCount === null) {
    return null;
  }

  return {
    items,
    totalCount,
    pageNumber: payload.pageNumber ?? payload.PageNumber ?? 1,
    pageSize: payload.pageSize ?? payload.PageSize ?? 10,
  };
}

export const getUserList = async (page, pageSize, sort = '', search = '', roleId = '') => {
  const { data: result } = await axiosInstance.get('/User/GetUserList', {
    params: {
      pageNumber: page,
      pageSize,
      ...(sort && { sort }),
      ...(search && { search }),
      ...(roleId && { roleId }),
    },
  });

  const paged = extractPagedItems(result?.data);
  if (paged) {
    return {
      ...paged,
      pageNumber: paged.pageNumber ?? page,
      pageSize: paged.pageSize ?? pageSize,
    };
  }

  const apiMessage = result?.message || result?.Message;
  if (apiMessage) {
    throw new Error(apiMessage);
  }

  console.error('Unexpected response structure:', result);
  throw new Error('Unexpected response while loading users');
};

export const addOrUpdateUser = async (userData) => {
  const formattedData = {
    ...userData,
    isActive: userData.isActive ? true : false,
  };

  // Password travels over HTTPS via axiosInstance; server hashes with bcrypt.
  const { data: responseData } = await axiosInstance.post(
    '/User/AddOrUpdateUser',
    formattedData
  );

  const responseCode = responseData?.code ?? responseData?.Code;
  const apiMessage = responseData?.message || responseData?.Message;

  if (responseCode === 403 || responseCode === 'Forbidden') {
    throw new Error(apiMessage || 'Failed to save user');
  }

  if (responseData.data) {
    return responseData.data;
  }

  return {
    ...formattedData,
    id: formattedData.id || `temp-${Date.now()}`,
  };
};

/** Permanently deletes a user via the management API. */
export const deleteUser = async (userId: number) => {
  const { data: responseData } = await axiosInstance.post(
    `/User/DeleteUser/${userId}`
  );

  const responseCode = responseData?.code ?? responseData?.Code;
  const failed =
    responseData?.data === false ||
    responseCode === 403 ||
    responseCode === 'Forbidden';

  if (failed) {
    const apiMessage = responseData?.message || responseData?.Message;
    throw new Error(apiMessage || 'Failed to delete user');
  }

  return responseData;
};
